<template>
  <!-- User logged-in -->
  <v-menu v-if="user" light left min-width="225px" transition="slide-y-transition">
    <template #activator="{ props }">
      <v-btn theme="dark" :icon="mdiAccount" title="Account" v-bind="props"> </v-btn>
    </template>
    <div
      class="px-4 py-6 text-white bg-black text-subtitle-1 font-weight-medium user-banner"
      @click.stop
    >
      {{ user.email }}
    </div>

    <v-list class="py-0">
      <v-list-item to="/user">
        <v-list-item-title>Account Settings</v-list-item-title>

        <template #append>
          <v-icon>{{ mdiCogs }}</v-icon>
        </template>
      </v-list-item>
      <v-divider />
      <v-list-item href="/logout">
        <v-list-item-title>Logout</v-list-item-title>

        <template #append>
          <v-icon>{{ mdiLogout }}</v-icon>
        </template>
      </v-list-item>
    </v-list>
  </v-menu>

  <!-- No User -->
  <v-btn v-else theme="dark" text class="ma-0" @click="loginDialog = true"> Log In </v-btn>
</template>

<script>
// Pinia stores
import { mapStoreState, mapFields } from '@/store/helpers'
import { mdiAccount, mdiCogs, mdiLogout } from '@mdi/js'

export default {
  data: () => ({
    mdiAccount,
    mdiCogs,
    mdiLogout
  }),
  computed: {
    ...mapStoreState('user', ['user']),
    ...mapFields({
      loginDialog: 'app.loginDialog'
    })
  }
}
</script>

<style lang="scss" scoped>
.user-banner {
  letter-spacing: 0.01em;
  border-bottom: 3px solid rgba(0, 0, 0, 0.12) !important;
}
</style>
